import { Button, Text } from "theme-ui";
const ClearFilterButton: React.FC<{
    onClick: () => void;
    label: React.ReactNode;
    sx?: any;
}> = ({ onClick, label, sx }) => (
    <Button onClick={onClick} className="dashboardFilterButton" sx={{ padding: "8px", border: "1px solid rgba(141, 141, 141, 0.2)" }}>
        <Text sx={{ fontSize: "14px", marginLeft: '8px', marginRight: '8px', color: 'rgba(141, 141, 141, 1)' }}>{label}</Text>
    </Button>
);

export default ClearFilterButton